import { render } from "./PsychologistLayout.vue?vue&type=template&id=1589c885"
import script from "./PsychologistLayout.vue?vue&type=script&lang=js"
export * from "./PsychologistLayout.vue?vue&type=script&lang=js"

import "./PsychologistLayout.vue?vue&type=style&index=0&id=1589c885&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__